import api, { updateDefaults } from './api';

export default {
  install: (Vue, options) => {
    updateDefaults(options);

    // eslint-disable-next-line no-param-reassign
    Vue.config.globalProperties.$api = api;
  },
};
